import useStyles from './styles';

function ListWithTicksFallback() {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <div className={styles.titleFallback}>
          <i className="skeleton" />
        </div>
        <ul className={styles.list}>
          {[...Array(8)].map((item, index) => (
            <div className={styles.itemFallback} key={`ListWithTicksFallback-${item}=${index}`}>
              <i className="skeleton" />
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default ListWithTicksFallback;
